export const GET_ORDER_CANCEL_REASONS_SUCCESS = 'lookups/GET_ORDER_CANCEL_REASONS_SUCCESS'
